import { render, staticRenderFns } from "./DailyVehicle.vue?vue&type=template&id=55af79ed&"
import script from "./DailyVehicle.vue?vue&type=script&lang=js&"
export * from "./DailyVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports